import React from 'react';

import ListIngredientsContainer from './components/ListIngredients.container';

const List = ({ history }) => <ListIngredientsContainer history={history} />;

export default List;
